import { store } from "../store";
import Controller from "./Controller";
import apiClientToken from "../plugins/axiosToken";

export default class DelegacionesService {
  getDelegaciones(context) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios + "WCFDelegaciones.svc/RestService/GetDelegaciones"
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener las delegaciones",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  getDelegacionesPorEstado(context, id_estado) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios + "WCFDelegaciones.svc/RestService/GetDelegacionesPorEstado/"+id_estado
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener las delegaciones",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  getDelegacion(context, id) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios + "WCFDelegaciones.svc/RestService/Get/" + id
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener la delegación",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  getDelegacionesByEstado(context, id_estado) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios + "WCFDelegaciones.svc/RestService/GetByEstado/" + id_estado
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener delegaciones por estado",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  getUsuariosPorSistema(context){
    var t = context     
    var controller = new Controller();
    return new Promise(function(resolve,reject){            
        apiClientToken.get(store.getters.getUrlServiciosAdmin + "WCFUsuarios.svc/RestService/getUsuariosPorSistema")        
        .then(function(response){
            resolve(controller.getData(context,response));
        })
        .catch(function(error){
          t.$toast.add({
              severity:"error",
              summary:"ERROR",
              detail:"Error al obtener datos del servidor",
              life: 3000
          });
          console.log(error);
          reject(error);
        })
    })
  }

  addDelegacion(context, param) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios + "WCFDelegaciones.svc/RestService/Add",
          param
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al crear la delegación",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  updateDelegacion(context, param) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios + "WCFDelegaciones.svc/RestService/Update",
          param
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al actualizar la delegación",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  deleteDelegacion(context, id) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios + 
          "WCFDelegaciones.svc/RestService/Delete/" + 
          id
        )
        .then(function (response) {
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al eliminar la delegación",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }
}